import { render } from "./BreadcrumbGroup.vue?vue&type=template&id=5d59b711&scoped=true"
import script from "./BreadcrumbGroup.vue?vue&type=script&lang=js"
export * from "./BreadcrumbGroup.vue?vue&type=script&lang=js"

import "./BreadcrumbGroup.vue?vue&type=style&index=0&id=5d59b711&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d59b711"]])

export default __exports__